import Vue from 'vue'
import Vuex from 'vuex'
import apiHelper from '@/services/apiHelper'

Vue.use(Vuex)

const state = {
  surveyGroup: [],
  surveys: [],
  surveyGroupById: [],
  surveyRoles: [],
  SurveyQue: [],
  user: [],
  userList: [],
  createdSurvey: [],
  addQueList: [],
  addedQuetion: [],
  result: [],
  createdRole: '',
  bulkUser: '',
  dummyUser: '',
  welcomeMailUsers: [],
  welcomeMail: {},
  SingleUser: {}
}
const getters = {
  getSurveyGroup (state) {
    return state.surveyGroup
  },
  getSurveys (state) {
    return state.surveys
  },
  getSurveyGroupById (state) {
    return state.surveyGroupById
  },
  getSurveyRoles (state) {
    return state.surveyRoles
  },
  getQuestions (state) {
    return state.SurveyQue
  },
  getUser (state) {
    return state.user
  },
  getUserList (state) {
    return state.userList
  },
  getCreatedSurvey (state) {
    return state.createdSurvey
  },
  getAddQueList (state) {
    return state.addQueList
  },
  getQuestion (state) {
    return state.addedQuetion
  },
  getResult (state) {
    return state.result
  },
  getRole (state) {
    return state.createdRole
  },
  getBulkUser (state) {
    return state.bulkUser
  },
  getDummyUser (state) {
    return state.dummyUser
  },
  getWelcomeMailUsers (state) {
    return state.welcomeMailUsers
  },
  getWelcomeMail (state) {
    return state.welcomeMail
  },
  getSingleUser (state) {
    return state.SingleUser
  }
}
const mutations = {
  setSingleUser (state, payload) {
    state.SingleUser = payload
  },
  setSurveyGroup (state, payload) {
    state.surveyGroup = payload
  },
  setSurveys (state, payload) {
    state.surveys = payload
  },
  setSurveyGroupById (state, payload) {
    state.surveyGroupById = payload
  },
  setSurveyRoles (state, payload) {
    state.surveyRoles = payload
  },
  setQuestions (state, payload) {
    state.SurveyQue = payload
  },
  setUser (state, payload) {
    state.user = payload
  },
  setUserList (state, payload) {
    state.userList = payload
  },
  setCreatedSurvey (state, payload) {
    state.createdSurvey = payload
  },
  setAddQueList (state, payload) {
    state.addQueList = payload
  },
  setQuestion (state, payload) {
    state.addedQuetion = payload
  },
  setResult (state, payload) {
    state.result = payload
  },
  setRole (state, payload) {
    state.createdRole = payload
  },
  setBulkUser (state, payload) {
    state.bulkUser = payload
  },
  setDummyUser (state, payload) {
    state.dummyUser = payload
  },
  setWelcomeMailUsers (state, payload) {
    state.welcomeMailUsers = payload
  },
  setWelcomeMail (state, payload) {
    state.welcomeMail = payload
  }
}
const actions = {
  fetchSurveys ({commit}) {
    apiHelper({
      url: '/surveys',
      method: 'GET'
    })
      .then(res => {
        console.log(res)
        commit('setSurveys', res)
      })
      .catch(error => {
        console.log(error)
        commit('setSurveys', 'Error')
      })
  },
  fetchSurveyGroup ({commit}) {
    console.log('fetch Survey Group')
    apiHelper({
      url: '/survey_groups',
      method: 'GET'
    })
      .then(res => {
        console.log(res)
        commit('setSurveyGroup', res)
      })
      .catch(error => {
        commit('setSurveyGroup', 'Error')
        console.log(error)
      })
  },
  addSurveyGroup ({commit}, payload) {
    console.log('Add Survey Group called', payload)
    apiHelper({
      url: '/add_survey_group',
      method: 'POST',
      data: {
        name: payload.name,
        surveys: payload.surveys
      }
    })
      .then(res => {
        console.log(res)
        // commit('setSurveyGroup', res.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  fetchSurveyGroupById ({commit}, payload) {
    apiHelper({
      url: '/survey_groups',
      method: 'GET',
      data: {
        id: payload.id
      }
    })
      .then(res => {
        console.log(res)
        commit('setSurveyGroupById', res.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  updateSurveyGroupById ({commit}, payload) {
    console.log('Edit Api called')
    apiHelper({
      url: '/update_survey_group',
      method: 'POST',
      data: {
        id: payload.id,
        name: payload.name,
        surveys: payload.surveys
      }
    })
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  fetchSurveyRoles ({commit}, payload) {
    apiHelper({
      url: '/roles',
      method: 'GET'
    })
      .then(res => {
        console.log(res)
        commit('setSurveyRoles', res)
      })
      .catch(error => {
        commit('setSurveyRoles', 'Error')
        console.log(error)
      })
  },
  assignSurveyByRole ({commit}, payload) {
    console.log('Assign Survey Payload', payload)
    apiHelper({
      url: '/assign_survey',
      method: 'POST',
      data: {
        role: payload.role,
        group_id: payload.group_id
      }
    })
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  deleteSurveyGroupById ({commit}, payload) {
    console.log('payload====', payload)
    console.log('delete survey group called')
    apiHelper({
      url: `/delete_survey_group?id=${payload.id}`,
      method: 'DELETE'
    }).then(res => {
      console.log('response:', res)
    }).catch(error => {
      console.log(error)
    })
  },
  fetchQuestions ({commit}, payload) {
    apiHelper({
      url: '/questions',
      method: 'GET'
    })
      .then(res => {
        console.log(res)
        commit('setQuestions', res)
      })
      .catch(error => {
        commit('setQuestions', 'Error')
        console.log(error)
      })
  },
  addUser ({commit}, payload) {
    console.log('add user gets called')
    try {
      apiHelper({
        url: '/create_user',
        method: 'post',
        data: payload
      })
        .then(res => {
          console.log(res)
          commit('setUser', res)
        })
        .catch(error => {
          console.log(error)
          commit('setUser', 'Error')
        })
    } catch (error) {
      console.log('Error', error)
      commit('setUser', 'Error')
    }
  },
  fetchSingleUser ({commit}, payload) {
    console.log('fetch single user gets called')
    apiHelper({
      url: `/users?id=${payload.id}`,
      method: 'get',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setSingleUser', res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  fetchUserList ({commit}, payload) {
    console.log('add user gets called')
    apiHelper({
      url: '/users',
      method: 'get',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setUserList', res)
      })
      .catch(error => {
        commit('setUserList', 'Error')
        console.log(error)
      })
  },
  updateUser ({commit}, payload) {
    console.log('add user gets called')
    apiHelper({
      url: '/update_user',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createSurvey ({commit}, payload) {
    console.log('add user gets called')
    apiHelper({
      url: '/create_survey',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setCreatedSurvey', res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  addQueToSurvey ({commit}, payload) {
    console.log('add questions gets called')
    apiHelper({
      url: '/add_questions_to_survey',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setAddQueList', res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createQuestion ({commit}, payload) {
    console.log('add questions gets called')
    apiHelper({
      url: '/create_question',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setQuestion', res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  fetchResult ({commit}, payload) {
    console.log('add result gets called', payload)
    apiHelper({
      url: `/check_answers`,
      method: 'POST',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setResult', res)
      })
      .catch(error => {
        // commit('setResult', res.data)
        console.log(error)
      })
  },
  createRole ({commit}, payload) {
    console.log('add role gets called', payload)
    apiHelper({
      url: '/create_role',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setRole', res)
      })
      .catch(error => {
        console.log(error)
        commit('setRole', 'Error')
      })
  },
  addBulkUser ({commit}, payload) {
    console.log('add bulk user gets called', payload)
    apiHelper({
      url: '/create_bulk_users',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setBulkUser', res)
      })
      .catch(error => {
        commit('setBulkUser', 'Error')
        console.log(error)
      })
  },
  addDummyUser ({commit}, payload) {
    console.log('add dummy user gets called')
    apiHelper({
      url: '/create_dummy_users',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setDummyUser', res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  fetchWelcomeMailUsers ({commit}, payload) {
    console.log('fetch fetchWelcomeMailUsers')
    apiHelper({
      url: `/get_users_by_role?role=${payload.role}`,
      method: 'GET'
    })
      .then(res => {
        console.log(res)
        commit('setWelcomeMailUsers', res)
      })
      .catch(error => {
        commit('setWelcomeMailUsers', 'Error')
        console.log(error)
      })
  },
  sendWelcomeMail ({commit}, payload) {
    console.log('welcome mail gets called')
    apiHelper({
      url: '/send_welcome_mail',
      method: 'post',
      data: payload
    })
      .then(res => {
        console.log(res)
        commit('setWelcomeMail', res)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/Survey/index.js